import PropTypes from 'prop-types';
import cx from 'classnames';
import Address from '../Address';

const AVIAddressLabel = ({
  address1,
  address2,
  city,
  country,
  state,
  locale,
  title,
  zipCode
}) => {
  return (
    <div className={cx('line-height-125')}>
      {title && <p className={cx('exclude-global', 'input__label')}>{title}</p>}
      <Address
        address1={address1}
        address2={address2}
        city={city}
        country={country}
        locale={locale}
        state={state}
        zipCode={zipCode}
      />
    </div>
  );
};

AVIAddressLabel.propTypes = {
  address1: PropTypes.string,
  address2: PropTypes.string,
  city: PropTypes.string,
  country: PropTypes.string,
  locale: PropTypes.string,
  state: PropTypes.string,
  title: PropTypes.string,
  zipCode: PropTypes.string
};

export default AVIAddressLabel;
